import gql from 'graphql-tag'

export const examTaskAlgorithmsAddresses = gql`
  query queriesAlgorithmsAddresses{
      examTaskAlgorithmsAdresses
  }
`
